import UiElement from '../../../shared/ui-element/ui-element';

import './side-scrolling-banner.scss';

class SideScrollingBanner extends UiElement {
  ui = {
    closeButton: '.js-close-side-scrolling',
    banner: '.js-side-scrolling-banner',
    article: '.article-content',
  };

  events = {
    'click @ui.closeButton': 'handleCloseButton',
  };

  screenHeight = document.documentElement.clientHeight;

  onInit() {
    super.onInit();

    if (this.ui.banner) {
      document.addEventListener('scroll', () => {
        this.handleScroll();
      });
    }
  }

  handleCloseButton() {
    this.ui.banner.remove();
    this.destroy();
  }

  handleScroll() {
    const scrolled = window.pageYOffset || document.documentElement.scrollTop;
    const bannerTop = (this.screenHeight - this.ui.banner.offsetHeight) / 2;

    if (scrolled > this.ui.article.offsetTop - bannerTop) {
      this.ui.banner.classList.add('-visible');
    }

    if (scrolled < this.ui.article.offsetTop - bannerTop / 2) {
      this.ui.banner.classList.remove('-visible');
    }

    if (scrolled > this.ui.article.offsetHeight + bannerTop) {
      this.ui.banner.classList.remove('-visible');
    }
  }
}

export default SideScrollingBanner;
